import { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import TextInput from '../../inputs/text-input/TextInput';
import FilePicker from '../../inputs/file-picker/FilerPicker';
import Button from '../../button/Button';
import Thumbnails from '../../thumbnails/Thumbnails';

import { ReactComponent as AttachmentIcon } from '../../../../resources/icons/attachment.svg';

import './comment-input.scss';

const CommentInput = ({ createComment }) => {
  const [message, setMessage] = useState('');
  const [images, setImages] = useState([]);

  const commentInputRef = useRef(null);
  const fileRef = useRef(null);

  const handleFileChange = ({ target }) => {
    const file = target.files[0];
    setImages([...images, file]);
  };

  const deleteImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const handlePostClick = () => {
    createComment(message, images, () => {
      setMessage('');
      setImages([]);
    });
  };

  const handleCommentChange = (value) => {
    const numLines = value.split('\n').length;
    const numWords = value.split(' ').length;

    setMessage(value);

    if (numWords / 13 > numLines) {
      const height = (numWords / 13) * 20 + 10;
      commentInputRef.current.style.height = `${height}px`;
    } else {
      const height = numLines * 20 + 10;
      commentInputRef.current.style.height = `${height}px`;
    }
  };

  return (
    <section className="comment-input">
      <div className="comment-input__input-container">
        <TextInput
          className="comment-input__input"
          ref={commentInputRef}
          value={message}
          placeholder="Comment..."
          onChange={({ target }) => handleCommentChange(target.value)}
          multiline
        />
        <Thumbnails images={images} deleteImage={deleteImage} />
      </div>
      <div className="comment-input__actions">
        <FilePicker
          fileRef={fileRef}
          enableFileLimit={true}
          triggerElement={<AttachmentIcon className="comment-input__icon" onClick={() => fileRef.current.click()} />}
          onChange={handleFileChange}
        />
        <Button className="comment-input__button" onClick={handlePostClick}>
          POST
        </Button>
      </div>
    </section>
  );
};

CommentInput.propTypes = {
  createComment: PropTypes.func.isRequired,
};

export default CommentInput;
